export default __webpack_public_path__ + "static/assets/med_gel_solid_01_b.3a9c0b65.png";